import useAppCustom from '@hooks/useAppCustom';
import { OrderLogResponse } from '@models/order/orderLog';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

function useOrderCancelable(orderLog: OrderLogResponse) {
    const { status, paymentSubMethod, createdAt } = orderLog;
    const { useOrderCancelButton } = useAppCustom().orderLog;
    const [isTimeBlock, setIsTimeBlock] = useState<boolean>(paymentSubMethod === 'DOCOMO' && status === 'NEW');

    // 도코모 사용 시 1분간 취소 버튼 미노출
    useEffect(() => {
        if (isTimeBlock) {
            const goal = dayjs(createdAt).add(1, 'minute');
            const interval = setInterval(() => {
                if (dayjs().isAfter(goal)) {
                    clearInterval(interval);
                    setIsTimeBlock(false);
                }
            }, 1000);
            return () => clearInterval(interval);
        }
        return () => {};
    }, [createdAt, isTimeBlock]);

    return useOrderCancelButton && status === 'NEW' && (!isTimeBlock);
}

export default useOrderCancelable;
